<template>
  <router-view />
</template>
<script>
  export default {
    name: 'LancamentoFaturasModule',
  }
</script>
